














































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EventModel, EventType, EventDrugJoinModel } from "@/models/event";
import Bleeding from "./Bleeding.vue";
import Operation from "./Operation.vue";
import Injection from "./Injection.vue";
import Inspection from "./Inspection.vue";
import MissedInjection from "./MissedInjection.vue";
import Physiotherapy from "./Physiotherapy.vue";
import Note from "./Note.vue";
import Sport from "./Sport.vue";
import Visit from "./Visit.vue";

@Component({
  components: {
    Bleeding,
    Operation,
    Injection,
    Inspection,
    MissedInjection,
    Physiotherapy,
    Note,
    Sport,
    Visit
  }
})
export class EventDetail extends Vue {
  @Prop({ required: true })
  event!: EventModel;

  EventType = EventType;

  async mounted() {}
  get formConfig() {
    return {
      comment: {
        label: this.$t("event.fields.comment"),
        disabled: true,
        readonly: true
      }
    };
  }

  private get headers() {
    return [
      {
        text: this.$t("event.fields.usedDrug"),
        align: "left",
        value: "name",
        sortable: false
      },
      {
        text: this.$t("drug.fields.expiresAt"),
        align: "left",
        value: "expiresAt",
        sortable: false
      },
      {
        text: this.$t("drug.fields.lotNo"),
        align: "left",
        value: "lotNo",
        sortable: false
      },
      {
        text: this.$t("drug.fields.takeAmount"),
        align: "left",
        value: "takeAmount",
        sortable: false
      }
    ];
  }
}

export default EventDetail;
